module.exports = __webpack_public_path__ + "img/antenna.8e7a5ca9.svg";